module.exports = __webpack_public_path__ + "static/temple-base-71cd286ef7c833e35f9cee398ca164d6.svg";